import React, { useState } from "react";
import { Modal, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { AntDesign } from "@expo/vector-icons";

export enum ImageOptionAction {
  CLOSE = "close",
  REPORT = "report",
  DELETE = "delete",
}

interface ImageOption {
  label: string;
  action: ImageOptionAction;
  icon: React.ComponentProps<typeof AntDesign>["name"];
}

interface ImageOptionsProps {
  onOptionSelected: (action: ImageOptionAction) => void;
  allowedOptions: ImageOptionAction[];
}

const ALL_IMAGE_OPTIONS: ImageOption[] = [
  { label: "Delete", action: ImageOptionAction.DELETE, icon: "delete" },
  {
    label: "Report",
    action: ImageOptionAction.REPORT,
    icon: "customer-service",
  },
  { label: "Close", action: ImageOptionAction.CLOSE, icon: "close-circle" },
];

function ImageOptions({
  onOptionSelected,
  allowedOptions,
}: ImageOptionsProps): React.JSX.Element {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const options = ALL_IMAGE_OPTIONS.filter((option) =>
    allowedOptions.includes(option.action),
  );

  const handleOptionPress = (action: ImageOptionAction): void => {
    onOptionSelected(action);
    hideModal();
  };

  const showModal = (): void => {
    setIsModalVisible(true);
  };

  const hideModal = (): void => {
    setIsModalVisible(false);
  };

  return (
    <View style={styles.container}>
      <TouchableOpacity onPress={showModal}>
        <Text style={styles.menuText}>≡</Text>
      </TouchableOpacity>
      {isModalVisible && (
        <Modal transparent visible={isModalVisible} onRequestClose={hideModal}>
          <TouchableOpacity style={StyleSheet.absoluteFill} onPress={hideModal}>
            <View style={styles.modalContainer}>
              <View style={styles.optionsContainer}>
                {options.map((option) => (
                  <TouchableOpacity
                    key={option.action}
                    style={styles.option}
                    onPress={() => handleOptionPress(option.action)}
                  >
                    <AntDesign
                      name={option.icon}
                      size={20}
                      color="black"
                      style={styles.optionIcon}
                    />
                    <Text style={styles.optionLabel}>{option.label}</Text>
                  </TouchableOpacity>
                ))}
              </View>
            </View>
          </TouchableOpacity>
        </Modal>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  menuText: {
    fontSize: 35,
    lineHeight: 35,
    color: "#FFFFFF",
    verticalAlign: "middle",
  },
  modalContainer: {
    flex: 1,
    justifyContent: "flex-end",
    alignItems: "center",
    paddingBottom: 20,
  },
  optionsContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "white",
    borderRadius: 12,
    padding: 16,
    width: "50%",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: -2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  option: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 12,
  },
  optionIcon: {
    marginRight: 16,
  },
  optionLabel: {
    fontSize: 16,
    marginLeft: -10,
    color: "black",
  },
});

export default ImageOptions;
